import * as packageJson from '../../package.json';

export const environment = {
  mock: false,
  production: false,
  local: true,
  serverUrl: '/epolicy/api',
  endpoint: {
    api: '/api/v1',
    otpUrl: '/api/v2/otp/token',
    epolicyAPI: '/api/v1/epolicies',
    ePortal: 'http://app-eportal-dev-az-general-insurance-thailand-dev.apps.ap1.crp.allianz/'
  },
  version: require('../../package.json').version
};
